import React from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../../components/formFields/FormTextField";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { openDialog, closeDialog } from "../../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../../components/dialog/Dialog";

const ServiceInfoArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const [deleteIndex, setDeleteIndex] = React.useState<number>(-1);

  const handleOpenDeleteDialog = (index: number) => {
    setDeleteIndex(index);
    dispatch(openDialog("serviceInfoDeleteDialog"));
  };

  const handleDeleteAction = () => {
    fieldArrayRenderProps.onRemove({ index: deleteIndex });
    dispatch(closeDialog());
    setDeleteIndex(-1);
  };

  const addService = () => {
    fieldArrayRenderProps.onPush({
      value: {
        ServiceName: "",
        Description: "",
      },
    });
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem style={{ marginBottom: 10, display: "flex", justifyContent: "end" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={addService}
          type="button"
        >
          Add Service Info
        </Button>
      </GridLayoutItem>

      {dialogName === "serviceInfoDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Service Information"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>Are you sure you want to delete this service info?</Typography.p>
              </GridLayoutItem>
              <GridLayoutItem style={{ display: "flex", justifyContent: "end" }}>
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={handleDeleteAction}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}

      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.map((_: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card" style={{ padding: 15, marginBottom: 10 }}>
              <GridLayout
                gap={{ rows: 10, cols: 10 }}
                cols={[{ width: "100%" }]}
              >
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    name={`ServiceInfo.${index}.ServiceName`}
                    wrapperClassName="m-0 w-100"
                    label="Service Name"
                    placeholder="e.g. Tour"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{ width: "32px", height: "32px", marginTop: "20px" }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "24px" }}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`ServiceInfo.${index}.Description`}
                    wrapperStyle={{ margin: 0 }}
                    label="Description"
                    component={FormRichTextField}
                    minHeight={100}
                  />
                </GridLayoutItem>

              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default ServiceInfoArray;
